var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2053.58,
    height: 2903.704,
    viewBox: "0 0 543.343 768.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.66 65.599h46.697v-47.26H660.66z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.177 2019.83h266.851v-183.88H527.177z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.177 2019.83h266.851v-247.88H527.177z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1540.185v2177.778H0z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.942 3465.12H2102.77V-256.919H618.942z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.477 1984.78h562.243V766.862H995.477z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1416.535 1907.389c-49.782-38.644-98.368-85.647-145.201-140.2-48.41-56.392-95.263-121.053-138.141-197.469-38.661-68.9-74.966-148.34-101.564-243.048-23.326-83.053-38.322-179.189-35.896-278.829 1.342-55.149 7.381-112.481 19.575-160.491 12.874-50.684 33.254-86.885 57.651-104.597 24.589-17.855 51.071-18.414 76.533-12.594 27.639 6.316 54.851 20.6 81.589 37.411 27.603 17.353 54.724 38.33 82.231 56.409 34.61 22.747 69.813 41.346 105.52 52.48 46.195 14.404 93.166 15.143 138.89-3.285v1071.605c-5.646-1.26-11.277-2.852-16.889-4.739-42.319-14.23-83.867-41.268-124.298-72.653"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.477 1984.78h562.243V766.862H995.477z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.477 1984.78h562.243V766.862H995.477z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.921 1992.71h189.563v-189.57H582.921z"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.921 1992.71h189.563v-189.56H582.921z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1540.185v2177.778H0z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-462.229 2816.91H1021.59V-905.13H-462.229z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.431-210.632c6.692 93.645 6.241 262.97-32.874 327.722-25.364 41.992-54.085 34.5-81.409 8.704C391.3 64.57 353.919-12.724 280.693-35.315 157.298-73.376 150.79 196.174 243.316 327.099c32.241 45.623 63.873 91.962 96.787 134.857 144.835 188.754 356.794 581.184 261.439 992.707-35.264 152.187-108.336 245.197-187.146 218.955-6.199-2.065-12.29-5.558-18.291-9.661C6.097 1397.263 1.666 2109.634 1.666 2109.634V-234.037c0 .424 523.891-.372 566.786-.474.748 7.925 1.408 15.889 1.979 23.879"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.871 2019.83h266.85v-183.88h-266.85z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1540.185v2177.778H0z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.891 2151.1H1515.57V-43.66H18.891z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.36 1251.38h46.7v-47.26h-46.7z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1468.87 3.598h46.7V-43.66h-46.7z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.871 2019.83h266.85v-247.88h-266.85z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.718 2012.15h46.697v-31.67h-46.697z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1464.74 2118.31h46.69v-31.66h-46.69z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1078.2 2111.89h46.7v-31.67h-46.7z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M950.045 41.92h46.697V10.253h-46.697z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.613 2151.1h66.855v-87.19h-66.855z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1323.17 1711.51h66.86v-87.19h-66.86z"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1137.14 986.7h66.85v-87.189h-66.85z"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.891 899.848h66.856V812.66H18.89z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.484 1369.03h66.856v-87.19h-66.856z"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.909 1256.49h66.856v-87.19h-66.856z"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.614 1992.71h189.563v-189.56H320.614z"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.614 1992.71h189.563v-189.57H320.614z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    spreadMethod: "pad",
    gradientTransform: "scale(-4129.6959 4129.6959) rotate(-39.576 .402 1.31)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    spreadMethod: "pad",
    gradientTransform: "scale(1313.7882 -1313.7882) rotate(71.565 .751 -.816)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    spreadMethod: "pad",
    gradientTransform: "scale(1679.762 -1679.762) rotate(45 .76 -.708)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    spreadMethod: "pad",
    gradientTransform: "scale(2197.8288 -2197.8288) rotate(-57.735 .085 -.464)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    spreadMethod: "pad",
    gradientTransform: "scale(1928.0629 -1928.0629) rotate(-46.998 .033 -.325)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    spreadMethod: "pad",
    gradientTransform: "scale(-2410.386 2410.386) rotate(-34.804 .339 1.85)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0f4c83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#003566"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h1540.185v2073.778H0z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#i)",
      stroke: "none"
    },
    d: "M0 0h1540.185v2177.778H0z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#j)",
      stroke: "none"
    },
    d: "M0 2177.032V0h818.75c17.776 104.218 32.57 215.951 41.321 338.116 6.778 94.642 9.476 194.914 5.055 292.3-4.633 102.047-17.036 196.02-34.441 272.919-29.543 130.517-74.504 185.057-117.353 197.367-43.808 12.586-88.094-13.029-130.535-55.185-61.921-61.507-120.878-180.298-185.749-187.712-26.664-3.046-56.599 16.7-73.974 105.329-16.958 86.508-20.037 224.053-10.33 325.067 9.832 102.314 32.523 173.088 55.773 225.788 27.96 63.381 58.464 107.204 88.313 154.113 27.699 43.531 57.078 87.583 80.581 162.256 11.116 35.313 19.58 78.902 26.016 129.298 6.317 49.479 10.304 108.249 5.128 162.158-2.028 21.131-5.09 39.369-8.868 55.218z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#k)",
      stroke: "none"
    },
    d: "M979.365 2177.778c-.21-2.661-.411-5.325-.602-7.992-6.811-95.324-6.352-267.682 33.462-333.596 25.82-42.744 55.056-35.117 82.869-8.859 66.011 62.32 104.062 141.001 178.6 163.996 125.606 38.744 132.23-235.637 38.047-368.91-32.819-46.44-65.018-93.61-98.522-137.273-147.431-192.137-363.189-591.6-266.125-1010.497 37.456-161.65 116.818-257.711 200.994-218.702 74.187 34.381 282.319 364.465 311.576 32.786 7.32-82.979-9.432-171.728-25.643-245.457A1901.286 1901.286 0 0 0 1423.967 0h116.218v2177.778z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    },
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57000703,
      stroke: "#557fa6",
      strokeOpacity: 1
    },
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(619.858 1791.578)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(632.133 1758.003)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(644.407 1724.427)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(656.682 1690.851)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(668.956 1657.276)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(681.23 1623.7)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(693.505 1590.126)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(705.78 1556.55)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(718.055 1522.975)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(730.329 1489.4)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(742.603 1455.824)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(754.878 1422.249)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(767.152 1388.674)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(779.427 1355.098)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(791.701 1321.523)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(803.976 1287.948)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(816.25 1254.373)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(828.525 1220.796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(840.8 1187.221)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(853.074 1153.646)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(865.348 1120.07)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(877.623 1086.496)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(889.897 1052.92)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(902.173 1019.345)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(914.447 985.77)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(926.722 952.194)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(938.996 918.619)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(951.27 885.044)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(963.545 851.468)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(975.82 817.893)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(988.095 784.318)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1000.369 750.742)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1012.643 717.167)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1024.918 683.591)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1037.192 650.016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1049.467 616.441)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1061.741 582.866)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1074.015 549.29)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1086.29 515.715)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1098.565 482.14)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1110.84 448.564)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1123.114 414.989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1135.389 381.414)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1147.663 347.839)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1159.937 314.263)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1172.213 280.687)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1184.487 247.112)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1196.762 213.537)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1209.036 179.962)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1221.31 146.386)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1233.585 112.811)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1245.86 79.236)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1258.134 45.66)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1270.41 12.085)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1282.684 -21.49)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1294.958 -55.066)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1307.232 -88.64)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1319.507 -122.216)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.141",
    transform: "translate(1331.781 -155.791)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1344.055 -189.368)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1356.33 -222.943)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#557fa6",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#557fa6",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(1368.605 -256.518)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#r)",
      stroke: "none"
    },
    d: "M1459.431 2177.778c15.031-56.604 19.388-129.153 19.169-191.599-.405-116.276-23.974-212.653-59.723-297.886-32.704-77.973-70.902-146.032-100.343-230.155-25.715-73.476-44.568-159.792-53.118-249.722-8.374-88.062-6.16-184.65 17.162-262.068 28.061-93.15 78.191-125.425 124.822-158.885 45.876-32.916 82.975-79.586 108.493-170.122 10.367-36.782 18.435-76.356 24.292-117.409v1677.846z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#s)",
      stroke: "none"
    },
    d: "M1.666 0h162.688c-31.673 60.535-18.482 191.26 34.517 266.254 26.312 37.233 52.125 75.049 78.985 110.055 118.196 154.038 291.173 474.29 213.355 810.124-28.777 124.197-88.412 200.101-152.725 178.685-5.059-1.685-10.03-4.537-14.928-7.885C5.418 1139.684 1.669 1720.444 1.666 1720.94zm370.893 101.975C336.562 67.991 310.941 27.944 279.428 0h184.363c-4.32 38.998-12.037 73.749-24.796 94.872-10.442 17.287-21.583 24.297-32.921 24.298-11.138.001-22.466-6.763-33.515-17.195",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    style: {
      opacity: 0.24000501
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-461.314 1143.367)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-449.04 1109.792)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-436.764 1076.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-424.49 1042.64)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-412.216 1009.065)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.142",
    transform: "translate(-399.941 975.49)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-387.666 941.915)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-375.392 908.34)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-363.117 874.764)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-350.843 841.188)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-338.568 807.613)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-326.294 774.038)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-314.02 740.463)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.142",
    transform: "translate(-301.745 706.887)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-289.47 673.312)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-277.195 639.737)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-264.921 606.16)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-252.647 572.586)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-240.372 539.01)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-228.097 505.435)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-215.823 471.86)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.142",
    transform: "translate(-203.548 438.285)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-191.274 404.71)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-179 371.134)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-166.725 337.558)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-154.45 303.983)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-142.175 270.408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-129.901 236.833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.142",
    transform: "translate(-117.627 203.257)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-105.352 169.682)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(-93.077 136.106)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(-80.803 102.53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-68.528 68.956)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-56.254 35.38)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-43.98 1.805)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(-31.705 -31.77)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0012598,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.142",
    transform: "translate(-19.43 -65.345)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(-7.155 -98.921)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(5.119 -132.496)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(17.393 -166.072)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(29.668 -199.647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(41.943 -233.222)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(54.217 -266.797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(66.492 -300.372)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.143",
    transform: "translate(78.766 -333.949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(91.04 -367.524)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(103.315 -401.099)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(115.59 -434.674)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(127.864 -468.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(140.139 -501.825)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(152.413 -535.4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.143",
    transform: "translate(164.688 -568.976)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.246 1673.143",
    transform: "translate(176.962 -602.551)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(189.237 -636.126)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(201.512 -669.702)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(213.786 -703.277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(226.06 -736.852)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(238.335 -770.427)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(250.61 -804.003)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(262.885 -837.578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.143",
    transform: "translate(275.16 -871.154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 733.245 1673.142",
    transform: "translate(287.433 -904.729)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#w)",
      stroke: "none"
    },
    d: "M1.666 1404.41V0h63.988c3.335 82.013 21.306 151.408 47.325 213.443 26.22 62.51 56.842 117.075 80.445 184.517 20.616 58.907 35.731 128.107 42.587 200.204 6.713 70.6 4.937 148.036-13.76 210.103-22.498 74.679-62.687 100.554-100.071 127.378-36.779 26.39-66.522 63.806-86.98 136.389-17.626 62.535-26.962 135.14-28.685 207.759-.992 41.82.758 83.98 5.09 124.617z",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "matrix(.35278 0 0 -.35278 0 768.272)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57000703
    },
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#567d9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 12.423 16.201L24.846 0 12.423-16.201z",
    transform: "translate(1130.286 1235.18)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#567d9f",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0-22.555-29.415L-45.11 0",
    transform: "translate(1165.264 1235.18)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 12.423 16.201L24.846 0 12.423-16.201z",
    transform: "translate(1479.798 -12.603)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#517da8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 12.423 16.201L24.846 0 12.423-16.201z",
    transform: "translate(671.586 49.398)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#517da8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0-22.555-29.415L-45.109 0",
    transform: "translate(706.563 49.398)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#517da8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0-22.555-29.415L-45.11 0",
    transform: "translate(189.621 2011.538)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#517da8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0 22.556 29.415L45.11 0",
    transform: "translate(1465.531 2087.255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#517da8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0-22.555-29.415L-45.11 0",
    transform: "translate(1124.105 2111.279)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#517da8",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m0 0-22.555-29.415L-45.11 0",
    transform: "translate(995.95 41.311)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(147.059 2131.812)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(180.676 2087.97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(133.904 2114.656)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.141 0 5.718S-1.209 1.577 0 0",
    transform: "translate(150.713 2092.736)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.141 0 5.718S-1.209 1.577 0 0",
    transform: "translate(167.521 2070.815)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.141 0 5.718S-1.209 1.577 0 0",
    transform: "translate(160.944 2149.92)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.141 0 5.718S-1.209 1.577 0 0",
    transform: "translate(177.753 2128)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(194.561 2106.079)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.143 0 5.719C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1341.617 1692.222)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.143 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.576-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(1375.234 1648.381)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.21-1.576 1.21-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1328.462 1675.067)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.143 0-5.719-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(1345.27 1653.147)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.208-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.208 1.576 0 0",
    transform: "translate(1362.079 1631.226)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.143 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(1355.502 1710.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1372.31 1688.41)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719s-3.176-1.577-4.385 0c-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(1389.119 1666.49)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.719-1.208-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.143 0 5.719C-3.176 1.576-1.208 1.576 0 0",
    transform: "translate(1155.583 967.409)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.21-1.577 1.21-4.142 0-5.719-1.209-1.577-3.176-1.577-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(1189.2 923.568)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(1142.429 950.254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1159.237 928.333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1176.046 906.412)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(1169.469 985.517)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1186.277 963.596)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(1203.086 941.676)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(37.337 880.557)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(70.954 836.716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(24.183 863.402)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.143 0 5.719C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(40.992 841.481)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.208-1.576 1.208-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(57.8 819.56)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719s-3.176-1.577-4.385 0c-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(51.222 898.666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(68.031 876.745)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(84.84 854.824)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(173.93 1349.734)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.143 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(207.548 1305.893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(160.776 1332.579)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719s-3.176-1.577-4.385 0c-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(177.584 1310.659)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719S-1.209 1.577 0 0",
    transform: "translate(194.393 1288.738)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.208-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.208 1.577 0 0",
    transform: "translate(187.815 1367.842)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.143 0-5.719-1.209-1.577-3.176-1.577-4.384 0-1.209 1.576-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(204.624 1345.922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(221.433 1324.002)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55999798
    },
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(804.355 1237.197)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(837.972 1193.356)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.143 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.576-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(791.201 1220.043)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.176-1.576-4.385 0-1.209 1.577-1.209 4.142 0 5.719C-3.176 1.576-1.209 1.576 0 0",
    transform: "translate(808.01 1198.122)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(824.818 1176.2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.143 0-5.719-1.209-1.577-3.177-1.577-4.386 0-1.209 1.576-1.209 4.142 0 5.719C-3.177 1.576-1.209 1.576 0 0",
    transform: "translate(818.241 1255.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.577 1.209-4.142 0-5.719-1.209-1.576-3.177-1.576-4.386 0-1.208 1.577-1.208 4.142 0 5.719C-3.177 1.576-1.209 1.576 0 0",
    transform: "translate(835.05 1233.385)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.209-1.576 1.209-4.142 0-5.718-1.209-1.577-3.176-1.577-4.385 0-1.209 1.576-1.209 4.142 0 5.718C-3.176 1.577-1.209 1.577 0 0",
    transform: "translate(851.858 1211.465)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.4dd8416162983ac596f84ed7e00e1761.svg";
export { ForwardRef as ReactComponent };